import React, {useState} from "react";
import EstacionamientoHeader from "./EstacionamientoHeader";
import "bootstrap/dist/css/bootstrap.min.css";
import EstacionamientoSmallHeader from "./EstacionamientoSmallHeader";
import { useNavigate, NavLink, Navigate } from "react-router-dom";
import Botonera from "./Botonera";
import Mapa from "./Mapa";
import MapaPuntoCarga from "../Mapas/MapaPuntoCarga";






const BotoneraPuntosCarga = () => {
    const navigate = useNavigate();
    const [lugar, setLugar] = useState({lugar: "123"});

    
    return (
        <>
        <section><main>
       <div class="container text-center" >
       <EstacionamientoSmallHeader texto="Puntos de carga" retorno="/estacionamiento"/>
                <MapaPuntoCarga/>
            </div>
        <Botonera/>
        </main></section>
        </>

    );
    }
export default BotoneraPuntosCarga;